import { ClerkProvider } from '@clerk/clerk-react';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from '~/containers/ErrorBoundary';
import NotificationCenter from '~/containers/NotificationCenter';
import { AnnouncementProvider } from '~/context/announcement';
import { AuthenticationProvider } from '~/context/authentication';
import { MonitorProvider } from '~/context/monitor';
import { NotificationProvider } from '~/context/notification';
import { OrganizationsProvider } from '~/context/organizations';
import Routes from './Routes';

function RoutesContainer() {
  return (
    <Router>
      <NotificationProvider>
        <ClerkProvider publishableKey={process.env.CLERK_PUBLISHABLE_KEY}>
          <AuthenticationProvider>
            <OrganizationsProvider>
              <AnnouncementProvider>
                <MonitorProvider>
                  <ErrorBoundary>
                    <Routes />
                  </ErrorBoundary>
                </MonitorProvider>
              </AnnouncementProvider>
            </OrganizationsProvider>
          </AuthenticationProvider>
        </ClerkProvider>
        <NotificationCenter />
      </NotificationProvider>
    </Router>
  );
}

export default RoutesContainer;
